<template>
    <div class="flex justify-center">
        {{ activeQueueCalls.length }}
    </div>
</template>
<script>
import queueColumnMixin from '@/mixins/queueAgentsColumnMixin'
import {QUEUE_RULE_NO_RULE} from "@/enum/queueDashboardStatistics";

export default {
    mixins: [ queueColumnMixin ],
    computed: {
        allQueuesIds() {
            return this.allQueues.map(queue => queue.queue_id)
        },
        answeredCalls () {
            const allExtensionsCalls = this.allRealtimeExtensions.map(extension => extension.calls).flat()

            return allExtensionsCalls.filter(call => !!call.answered)
        },
        /**
         * All the calls which are assigned to the queue and are answered by checking the queue id parameter of the call
         *
         * @returns {Call[]}
         */
        activeQueueCalls() {
            if (this.isAll) {
                return this.answeredCalls.filter(call => this.allQueuesIds.includes(call.queueID))
            }

            const queueCalls = this.answeredCalls.filter(call => call.queueID === this.queue.queue_id)

            if (this.queueRuleID === QUEUE_RULE_NO_RULE) {
                // TODO RTD-695 make sure that queueRule is the right property
                return queueCalls.filter(call => !call.queueRule)
            } else if (this.queueRuleID !== null) {
                // TODO RTD-695 make sure that queueRule is the right property
                return queueCalls.filter(call => Number(call.queueRule) === Number(this.queueRuleID))
            } else {
                return queueCalls
            }
        }
    }
}
</script>
